import React, { useEffect, useState } from 'react'
import { Grid, GridColumn as Column, GridNoRecords } from '@progress/kendo-react-grid';
// * Helpers
import Notifications, { ERROR_NOTIFICATION } from '../../helpers/notifications';
import { useTranslation } from 'react-i18next';
import API from "../../services/api";

/*List of icons used in this component*/
/**Important: to see the full icons list visit: https://react-icons.github.io/react-icons */
import { ImArrowRight, ImArrowLeft } from 'react-icons/im'

const Step5 = (props) => {
    // * we call the hook to make translations
    const { t } = useTranslation('common');
    // * List of data. Used to fill the grid
    const [gridList, setGridList] = useState([])

    // we use useEffect to call the function that returns the step1 data
    useEffect(() => {
        if (props.activeStep === 5) {
            getStep5Data();
        }
    }, [props.activeStep]);// eslint-disable-line react-hooks/exhaustive-deps

    // * This line is used so that the numerical inputs have the thousands separator with comma
    const addCommas = num => num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    // * Gets the respective data to fill the Grid
    const getStep5Data = async () => {
        try {
            // gets data from API
            const response = await API.get(`/model/step5GetData?modelId=${props.modelData.modelid}`);
            // if error in request
            if (response.data.code !== 100) {
                Notifications.notify(response.data.msg, ERROR_NOTIFICATION);
                return;
            } else {
                const data = response.data.data.map((element, i) => {
                    // Ex: totalPopulation comes from DB, here we chaange that by Total population
                    // const refpopulation = t(`referencePopMatrixCode.${element.referencePopMatrixCode}`);

                    // change the variable for the real name
                    // element.referencePopMatrixCode = refpopulation;
                    // Sex validations
                    let formatedSex = ''
                    if (!element.indIncludeFemale) {
                        formatedSex = t('modals.sex_m');
                    } else if (element.indIncludeFemale) {
                        formatedSex = t('modals.sex_f');
                    } else {
                        formatedSex = t('modals.sex_b');
                    }

                    let itexpValue = 0;
                    if (element.beneficiaryUnit === 'i') {
                        itexpValue = ((element.icPm + element.icPf) * element.ibam * element.iantrans) + element.iadm;
                    } else {
                        itexpValue = (element.ichh * element.ibam * element.iantrans) + element.iadm;
                    }

                    let totalValue = 0;
                    if (element.beneficiaryUnit === 'i') {
                        totalValue = element.icPm + element.icPf;
                    } else {
                        totalValue = "-";
                    }

                    return {
                        ...element,

                        // referencePopMatrixCode: t(`referencePopMatrixCode.${element.referencePopMatrixCode}`),
                        formatedSex: formatedSex,
                        fullData: response.data.data,
                        itexp: addCommas(itexpValue),
                        total: addCommas(totalValue),
                        iantrans: addCommas(element.iantrans),
                        ibam: addCommas(element.ibam),
                        iadm: addCommas(element.iadm),
                        ichh: addCommas(element.ichh),
                        icPm: addCommas(element.icPm),
                        icPf: addCommas(element.icPf)
                    }
                });
                setGridList(data);
            }
        } catch (e) {
            Notifications.notify(String(e), ERROR_NOTIFICATION);
            console.log(e);
        }
    }

    // * This function is called when the PREVIOUS arrow is clicked.
    // * It is passed as parameter to each step 
    const onPreviousClick = () => {
        props.changeStep(4);
    }

    // * This function is called when the NEXT arrow is clicked.
    // * It is passed as parameter to each step 
    const onNextClick = () => {
        props.changeStep(6);
    }

    // * Returns the information to be displayed in the ICHH column
    const showICHHColumn = (props) => {
        // if household
        let avgString = "-";
        if (props.dataItem.beneficiaryUnit === "h") {
            avgString = `${props.dataItem.ichh}`;
        }

        return (
            <td className="grid-aling-numbers">
                {avgString}
            </td>
        );
    }

    const showICPMaleColumn = (props) => {
        // if household
        let avgString = "-";
        if (props.dataItem.beneficiaryUnit === "i") {
            avgString = `${props.dataItem.icPm}`;
        }

        return (
            <td className="grid-aling-numbers">
                {avgString}
            </td>
        );
    }

    const showICPFemaleColumn = (props) => {
        // if household
        let avgString = "-";
        if (props.dataItem.beneficiaryUnit === "i") {
            avgString = `${props.dataItem.icPf}`;
        }

        return (
            <td className="grid-aling-numbers">
                {avgString}
            </td>
        );
    }

    const titleStyle = (props) => {
        return (
            <span className="grids_titles_styles">
                {props.title}
            </span>
        );
    }

    return (
        <div className="col-md-12">
            <div className="row">
                <h6>{t('model.step5_desc')}</h6>
            </div>
            <div className="row row_attrs container_steps">
                <div className="col-sm-12">
                    <Grid style={{ height: '100%' }} data={gridList} resizable={true}>
                        {/* this is the message when there are no records */}
                        <GridNoRecords>{t('grids.no_records')}</GridNoRecords>
                        {/* columns of the grid */}
                        <Column headerClassName="grid-header-columns" field="benefitName" title={t('model.step5_benefitName')} width="150" headerCell={titleStyle} />
                        <Column headerClassName="grid-header-columns" field="groupName" title={t('model.step5_groupName')} width="150" headerCell={titleStyle}/>
                        <Column headerClassName="grid-header-columns" className="grid-aling-numbers" field="iantrans" title={t('model.step5_iantrans')} width="100" headerCell={titleStyle}/>
                        <Column headerClassName="grid-header-columns" className="grid-aling-numbers" field="ibam" title={t('model.step5_ibam')} width="150" headerCell={titleStyle}/>
                        <Column headerClassName="grid-header-columns" className="grid-aling-numbers" field="itexp" title={t('model.step5_itexp')} width="150" headerCell={titleStyle}/>
                        <Column headerClassName="grid-header-columns" className="grid-aling-numbers" field="iadm" title={t('model.step5_iadm')} width="150" headerCell={titleStyle} />
                        <Column headerClassName="grid-header-columns" className="grid-aling-numbers" title={t('model.step5_coveredPop')}>
                            <Column headerClassName="grid-header-columns" className="grid-aling-numbers"
                                field="fullData"
                                title={t('model.step5_numb_hh')}
                                cell={showICHHColumn}
                                width="150" 
                                headerCell={titleStyle}
                            />
                            <Column headerClassName="grid-header-columns" className="grid-aling-numbers" title={t('model.step5_individuals')}>
                                <Column headerClassName="grid-header-columns" className="grid-aling-numbers"
                                    field="fullData"
                                    title={t('model.step5_male')}
                                    cell={showICPMaleColumn}
                                    width="100" 
                                    headerCell={titleStyle}
                                />
                                <Column headerClassName="grid-header-columns" className="grid-aling-numbers"
                                    field="fullData"
                                    title={t('model.step5_female')}
                                    cell={showICPFemaleColumn}
                                    width="100" 
                                    headerCell={titleStyle}
                                />
                                <Column headerClassName="grid-header-columns" className="grid-aling-numbers"
                                    field="total"
                                    title={t('model.step5_total')}
                                    width="100" 
                                    headerCell={titleStyle}
                                />
                            </Column>
                        </Column>
                    </Grid>
                </div>
            </div>
            <div className="row arrows_position">
                <div className="col-sm-12">
                    <button className="btn_style" type="button" onClick={() => { onPreviousClick(); }} ><ImArrowLeft /></button>
                    <button className="btn_style" type="button" onClick={() => { onNextClick(); }} ><ImArrowRight /></button>
                </div>
            </div>
        </div>
    );
}

export default Step5